import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { animated, useSpring } from 'react-spring';
import { styled } from 'styled-components';
import { onEnterPress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { Label } from "../../label/src";
import { focusOutline, FONT_BRIGHTNESS_MAPPING, useTheme, } from "../../theme/src";
const AnimatedBox = animated(Box);
export const ToggleInput = ({ ariaLabel, checked = false, dataTestId, id, isDisabled = false, label, labelPosition = 'right', onChange, }) => {
    const theme = useTheme();
    const fontBrightness = theme.themeVariables.inputFontBrightness;
    const sliderInactiveBackgroundColor = FONT_BRIGHTNESS_MAPPING.black[fontBrightness];
    const sliderPositionStyle = useMemo(() => ({
        backgroundColor: checked
            ? theme.colors.white
            : sliderInactiveBackgroundColor,
        left: checked ? 26 : 0,
    }), [checked, sliderInactiveBackgroundColor, theme.colors.white]);
    const wrapperColorStyle = useMemo(() => ({
        backgroundColor: checked
            ? theme.checkbox.background.checked
            : theme.checkbox.background.unchecked,
    }), [
        checked,
        theme.checkbox.background.checked,
        theme.checkbox.background.unchecked,
    ]);
    const [sliderPosition, sliderPositionApi] = useSpring(() => sliderPositionStyle);
    const [wrapperColor, wrapperColorApi] = useSpring(() => wrapperColorStyle);
    useEffect(() => {
        sliderPositionApi.start(sliderPositionStyle);
        wrapperColorApi.start({
            backgroundColor: checked
                ? theme.checkbox.background.checked
                : theme.checkbox.background.unchecked,
        });
    }, [
        checked,
        sliderPositionApi,
        sliderPositionStyle,
        theme.checkbox.background.checked,
        theme.checkbox.background.unchecked,
        wrapperColorApi,
    ]);
    return (_jsxs(StyledBox, { "$isDisabled": isDisabled, "data-testid": dataTestId, children: [label && labelPosition === 'left' && (_jsx(Label, { id: id, position: labelPosition, children: label })), _jsxs(Wrapper, { onKeyPress: onEnterPress(onChange), style: wrapperColor, tabIndex: 0, children: [_jsx(Slider, { style: sliderPosition }), _jsx(Input, { "aria-label": ariaLabel, checked: checked, id: id, onChange: onChange, tabIndex: -1, type: "checkbox" })] }), label && labelPosition === 'right' && (_jsx(Label, { id: id, position: labelPosition, children: label }))] }));
};
const Input = styled.input `
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
  // To avoid zoom on iOS mobile devices, inputs must have font-size set to 16px (font-size is not really used here, no need to scope to only s & m)
  font-size: ${({ theme }) => theme.fontSizes[3]} !important;
`;
const Wrapper = styled(AnimatedBox).attrs(() => ({
    position: 'relative',
})) `
  height: ${({ theme }) => theme.space[5]}px;
  width: ${({ theme }) => theme.space[12]}px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.checkbox.border.color};
  ${focusOutline}
`;
const Slider = styled(AnimatedBox).attrs(() => ({
    display: 'block',
    m: '2px',
    mt: '1px',
    position: 'absolute',
})) `
  height: ${({ theme }) => theme.space[4]}px;
  width: ${({ theme }) => theme.space[4]}px;
  border-radius: 50%;
`;
const StyledBox = styled(Box) `
  ${({ $isDisabled }) => $isDisabled &&
    `
    opacity: 0.4;
    user-select: none;
    pointer-events: none;
    `}
`;
//# sourceMappingURL=ToggleInput.js.map